import { Component, computed, inject, input } from '@angular/core'
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component'
import { BreadcrumbItemComponent } from '../breadcrumb-item/breadcrumb-item.component'
import { BreadcrumbRouterService } from './breadcrumb-router.service'
import { toSignal } from '@angular/core/rxjs-interop'
import { BreadcrumbItem } from '../breadcrumb-item.interface'

@Component({
    selector: 'sf-breadcrumb-router, [sfBreadcrumbRouter]',
    imports: [BreadcrumbComponent, BreadcrumbItemComponent],
    templateUrl: './breadcrumb-router.component.html',
})
export class BreadcrumbRouterComponent {
    readonly #breadcrumbRouterService = inject(BreadcrumbRouterService)

    /**
     * Optional array of IBreadcrumbItem to override default BreadcrumbRouter behavior. [docs]
     * @return IBreadcrumbItem[]
     */
    readonly items = input<BreadcrumbItem[]>()

    readonly #breadcrumbs = toSignal(this.#breadcrumbRouterService.breadcrumbs$)

    readonly breadcrumbs = computed(() => {
        return this.items() ?? this.#breadcrumbs() ?? []
    })
}
